<template>
  <div class="curation-index">
    <h2 class="jps-section-title">{{ lss('目次', 'Table of Contents') }}</h2>
    <ul>
      <li v-for="index in indexStructure" :key="index.cpid">
        <a :href="'#' + index.cpid">{{ ls(index.title) }}</a>
        <ul v-if="index.index.length">
          <li v-for="subIndex in index.index" :key="subIndex.cpid">
            <a :href="'#' + subIndex.cpid">{{ ls(subIndex.title) }}</a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
const { ls, lss } = useI18n()

interface Props {
  def: PartIndex
  curation: Curation
}
const props = withDefaults(defineProps<Props>(), {})

const indexStructure = computed(() => {
  return extractIndex(props.curation.parts)
})

const extractIndex = (parts: CurationPartDefinition[]) => {
  if (!parts || parts.length === 0) {
    return [];
  }

  return parts
    .filter(p => p.type === 'jps-curation-section')
    .map(section => {
      return {
        title: section.title,
        cpid: section.cpid,
        index: extractIndex(section.parts),
      }
    })
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.curation-index {
  @include base-content-width();
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  > ul {
    padding: 1rem;
    border: $basic-border;
    background: $white;
    font-size: 0.75rem;
    border-radius: 8px;
    li {
      padding-bottom: 1rem;
      font-weight: bold;
      &:last-child {
        padding-bottom: 0;
      }
    }
    ul {
      margin-top: 1rem;
      margin-left: 2rem;
    }
  }
}
</style>
